/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarEvent } from '../../models/calendar-event';
import { CalendarEventUpdate } from '../../models/calendar-event-update';

export interface UpdateCalendarEvent$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: CalendarEventUpdate
}

export function updateCalendarEvent(http: HttpClient, rootUrl: string, params: UpdateCalendarEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarEvent>> {
  const rb = new RequestBuilder(rootUrl, updateCalendarEvent.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendarEvent>;
    })
  );
}

updateCalendarEvent.PATH = '/api/v1/calendars/default/events/{id}';
